var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceConference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10C13.7165 10 14.5 9.2165 14.5 8.25C14.5 7.2835 13.7165 6.5 12.75 6.5C11.7835 6.5 11 7.2835 11 8.25C11 9.2165 11.7835 10 12.75 10Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.982 12.5C14.994 12.418 15 12.334 15 12.25C15 11.284 14.216 10.5 13.25 10.5H12.25C11.284 10.5 10.5 11.284 10.5 12.25C10.5 12.334 10.506 12.418 10.518 12.5H14.982Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10C8.2165 10 9 9.2165 9 8.25C9 7.2835 8.2165 6.5 7.25 6.5C6.2835 6.5 5.5 7.2835 5.5 8.25C5.5 9.2165 6.2835 10 7.25 10Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.482 12.5C9.494 12.418 9.5 12.334 9.5 12.25C9.5 11.284 8.716 10.5 7.75 10.5H6.75C5.784 10.5 5 11.284 5 12.25C5 12.334 5.006 12.418 5.018 12.5H9.482Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H3C2.448 4 2 4.442 2 4.986V15.014C2 15.558 2.448 16 3 16H17C17.552 16 18 15.558 18 15.014V4.986C18 4.442 17.552 4 17 4ZM16.5 5.5V14.5H3.5V5.5H16.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C10.9665 11 11.75 10.2165 11.75 9.25C11.75 8.2835 10.9665 7.5 10 7.5C9.0335 7.5 8.25 8.2835 8.25 9.25C8.25 10.2165 9.0335 11 10 11Z",
    fill: "#FFC629"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.232 13.5C12.244 13.418 12.25 13.334 12.25 13.25C12.25 12.284 11.466 11.5 10.5 11.5H9.5C8.534 11.5 7.75 12.284 7.75 13.25C7.75 13.334 7.756 13.418 7.768 13.5H12.232Z",
    fill: "#FFC629"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5H9C8.448 5 8 4.552 8 4C8 3.448 8.448 3 9 3H11C11.552 3 12 3.448 12 4C12 4.552 11.552 5 11 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceConference);
export default __webpack_public_path__ + "static/media/vip-lounge-service-conference.bf529724aa5ee024af78cf6fbd099f09.svg";
export { ForwardRef as ReactComponent };